import OfferRatePKO from './OfferRatePKO';

export default OfferRatePKO;
